"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAstByObject = exports.getAstByString = void 0;
const parse = require("json-to-ast");
function getAstByString(jsonString, json) {
    const jsonAST = parse(jsonString, { loc: true });
    return {
        json: json || JSON.parse(jsonString),
        jsonString,
        jsonAST,
    };
}
exports.getAstByString = getAstByString;
function getAstByObject(json, indent = 4) {
    const jsonString = JSON.stringify(json, null, indent);
    return getAstByString(jsonString);
}
exports.getAstByObject = getAstByObject;
